import { render, staticRenderFns } from "./AkHtmlReadOnly.vue?vue&type=template&id=221cff6f"
import script from "./AkHtmlReadOnly.vue?vue&type=script&lang=js"
export * from "./AkHtmlReadOnly.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports